import { useState, useEffect } from "react";
import PropTypes from "prop-types";

import { ChevronDownIcon } from "primereact/icons/chevrondown";
import { ChevronRightIcon } from "primereact/icons/chevronright";
import { Dropdown } from "primereact/dropdown";

import BandeiraBr from "assets/img/bandeiras/br.png";
import BandeiraEn from "assets/img/bandeiras/en.png";
import BandeiraEs from "assets/img/bandeiras/es.png";

import { useLanguage } from "context/LanguageContext";

const ChangeLanguage = ({ notLabel }) => {
  const { currentLanguage, changeLanguage, GetTranslation } = useLanguage();

  const countries = [
    { name: "Português Brasil", code: "BR" },
    { name: "Espanhol", code: "ES" },
    { name: "Inglês", code: "EN" }
  ];

  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    if (selectedCountry != null)
      changeLanguage(selectedCountry.code.toLocaleLowerCase());
  }, [selectedCountry, changeLanguage]);

  useEffect(() => {
    const FilteredCountries = (item) => {
      return countries.filter((country) =>
        country.code.toLowerCase().includes(item)
      )[0];
    };

    if(selectedCountry == null)
        setSelectedCountry(FilteredCountries(currentLanguage));
  }, [selectedCountry]);

  const SelectedCountryTemplate = (option, props) => {
    if (option) {
      if (option.code === "BR")
        return (
          <div className="d-flex align-items-center gap-2">
            <img
              alt={option.code}
              src={BandeiraBr}
              className={`mr-2 d-flex`}
              style={{ width: "18px" }}
            />
            {option.name}
          </div>
        );
      if (option.code === "ES")
        return (
          <div className="d-flex align-items-center gap-2">
            <img
              alt={option.code}
              src={BandeiraEs}
              className={`mr-2 d-flex`}
              style={{ width: "18px" }}
            />
            {option.name}
          </div>
        );
      if (option.code === "EN")
        return (
          <div className="d-flex align-items-center gap-2">
            <img
              alt={option.code}
              src={BandeiraEn}
              className={`mr-2 d-flex`}
              style={{ width: "18px" }}
            />
            {option.name}
          </div>
        );

      return <div className="d-flex align-items-center">{option.name}</div>;
    }

    return <span>{props.placeholder}</span>;
  };

  const CountryOptionTemplate = (option) => {
    if (option.code === "BR")
      return (
        <div className="d-flex align-items-center gap-2">
          <img
            alt={option.name}
            src={BandeiraBr}
            className={`mr-2 d-flex`}
            style={{ width: "18px" }}
          />
          {option.name}
        </div>
      );
    if (option.code === "ES")
      return (
        <div className="d-flex align-items-center gap-2">
          <img
            alt={option.name}
            src={BandeiraEs}
            className={`mr-2 d-flex`}
            style={{ width: "18px" }}
          />
          {option.name}
        </div>
      );
    if (option.code === "EN")
      return (
        <div className="d-flex align-items-center gap-2">
          <img
            alt={option.name}
            src={BandeiraEn}
            className={`mr-2 d-flex`}
            style={{ width: "18px" }}
          />
          {option.name}
        </div>
      );

    return <div className="d-flex align-items-center">{option.name}</div>;
  };

  return (
    <div className="d-flex flex-column gap-2">
      {notLabel === false && <label>{GetTranslation("language")}</label>}
      <Dropdown
        value={selectedCountry}
        onChange={(e) => setSelectedCountry(e.value)}
        options={countries}
        optionLabel="name"
        placeholder="Select a Country"
        valueTemplate={SelectedCountryTemplate}
        itemTemplate={CountryOptionTemplate}
        className="w-100"
        dropdownIcon={(opts) => {
          return opts.iconProps["data-pr-overlay-visible"] ? (
            <ChevronRightIcon {...opts.iconProps} />
          ) : (
            <ChevronDownIcon {...opts.iconProps} />
          );
        }}
      />
    </div>
  );
};

ChangeLanguage.propTypes = {
  notLabel: PropTypes.bool
};

ChangeLanguage.defaultProps = {
  notLabel: false
};

export default ChangeLanguage;
